export class NotFoundError extends Error {
	constructor(message?: string) {
		super(message || 'Resursen kunde inte hittas');
		this.name = 'NotFoundError';
	}
}

export function isNotFoundError(error: unknown): error is NotFoundError {
	return error instanceof NotFoundError || (error as any)?.name === 'NotFoundError';
}
